import React from 'react';
import { TextField, Autocomplete } from '@mui/material';
import { FieldLabel } from 'components/Form/FormField';
import { DropdownInterface, DropdownOption } from 'components/DropdownSelect/dropdown.types';
import styled from 'styled-components';

const AutocompleteContainer = styled.div<{ $containedLabel?: boolean; $marginTop?: string }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${(props) => props.$containedLabel && 'margin-top: 1rem'}
  ${(props) => props.$marginTop && `margin-top: ${props.$marginTop};`}
`;

export type MultiselectDropdownProps = DropdownInterface<DropdownOption[], DropdownOption[]>;

const MultiselectDropdown = ({
  fieldLabel,
  allOptions,
  selected,
  setSelected,
  fullWidth,
  sx,
  placeholder,
  variant,
  containedLabel,
  marginTop,
  inputProps,
}: MultiselectDropdownProps): JSX.Element => {
  return (
    <AutocompleteContainer $containedLabel={containedLabel} $marginTop={marginTop}>
      {!containedLabel && <FieldLabel>{fieldLabel}</FieldLabel>}
      <Autocomplete
        fullWidth={fullWidth}
        id={`${fieldLabel}-multiselect-dropdown`}
        options={allOptions}
        getOptionLabel={(option) => option.name || ''}
        value={selected}
        onChange={(_event: React.SyntheticEvent, newValue: DropdownOption[]) => {
          setSelected(newValue);
        }}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            variant={variant ?? 'outlined'}
            placeholder={placeholder}
            label={containedLabel && fieldLabel}
            {...inputProps}
          />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        sx={sx}
        multiple
      />
    </AutocompleteContainer>
  );
};

export default MultiselectDropdown;
